<template>
  <div class="px-6 py-6">
    <div class="pb-6">
      <h2 class="text-3xl font-semibold text-ontick-carbon-900 dark:text-gray-300">Mensagens</h2>
      <p class="text-sm text-ontick-carbon-900 dark:text-gray-300">Veja aqui todas as suas mensagens</p>
    </div>
    <div class="overflow-hidden sm:rounded-md">
      <ul v-show="!placeholder" class="space-y-4 rounded-md">
        <li
          v-show="error_msg != 'Nenhuma notificação encontrada'"
          v-for="(item, index) in data"
          :key="index"
          class="w-full rounded-lg px-4 py-3"
          :class="
            index % 2 === 0 ? 'bg-ontick-steel-100 dark:bg-ontick-steel-500' : 'bg-gray-50 dark:bg-ontick-steel-700'
          "
          @mouseover="readMessage(item)"
        >
          <div class="flex space-x-4">
            <!-- <transition name="fade" mode="out-in"> -->
            <span
              :class="
                item.status === 'UNREAD'
                  ? [
                      selectedColor(item.color),
                      'mt-2 flex h-5 w-[50px] items-center justify-center rounded text-xs font-medium uppercase',
                    ]
                  : [selectedColor(item.color), 'mx-[15px] mt-2 h-5 w-5 rounded-full']
              "
              class="transition-all duration-300"
            >
              {{ item.status === "UNREAD" ? "Nova" : "" }}
            </span>
            <!-- </transition> -->

            <dd class="flex flex-col">
              <div class="flex items-baseline text-xs text-ontick-carbon-900 dark:text-gray-400">
                {{ item.datetime | moment("DD/MM/YYYY hh:mm:ss") }}
              </div>

              <p class="trucante py-1 text-left text-sm font-semibold text-ontick-carbon-900 dark:text-gray-300">
                {{ item.title }}
              </p>
              <p class="text-left text-xs text-ontick-carbon-900 dark:text-gray-300 md:block">
                <span v-html="item.message"></span>
              </p>
            </dd>
          </div>
        </li>
        <li v-show="error_msg == 'Nenhuma notificação encontrada'">
          <p class="py-20 text-center text-2xl font-medium text-ontick-carbon-900 dark:text-gray-300">
            {{ error_msg }}
          </p>
        </li>
      </ul>

      <placeholderTable v-show="placeholder" />
    </div>
  </div>
</template>

<script>
import placeholderTable from "@/app/shared/components/placeholder/placeholder-table.component.vue";
import { mapActions } from "vuex";

export default {
  name: "messages",

  components: {
    placeholderTable,
  },

  data() {
    return {
      data: [],
      readMessageIds: [],
      placeholder: false,
      error_msg: "",
    };
  },

  methods: {
    ...mapActions({ setMessages: "config/setMessages" }),
    readMessage(message) {
      if (message.status === "UNREAD") {
        setTimeout(() => {
          message.status = "READ";

          this.$api.post(`${this.$endpoint.POST_NOTIFICATIONS_READ}/${message.nf_id}`).catch((err) => {
            console.error(err);
          });
        }, 300);
      }
    },
    selectedColor(value) {
      let colors = {
        GREEN: "bg-ontick-green-500",
        YELLOW: "bg-ontick-yellow-500",
        BLUE: "bg-ontick-blue-500",
        RED: "bg-ontick-red-500",
      };
      return colors[value];
    },
    getMessages() {
      return new Promise((resolve, reject) => {
        this.setMessages()
          .then((res) => {
            this.data = res;

            resolve();
          })
          .catch((error) => {
            this.error_msg = error.data.msg;
            reject(error.data.msg);
          });
      });
    },
  },

  created() {
    this.placeholder = true;
    this.getMessages().finally(() => {
      this.placeholder = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./notification.component.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
